<template>
	<div>
		<card-template>
			<template slot="titleCard">
				<i class="fa fa-filter fa-lg"></i> {{ this.$t('Filter') }}
			</template>
			<div class="row">
				<div class="col-12 col-md-3">
					<label for="">{{ this.$t('DateRange') }}</label>
					<DatePickerComponent
						v-model="filterDateRange"
            :show-label="false"
						@range="setDateFilter"
					></DatePickerComponent>
				</div>
				<div class="col-12 col-md-3">
					<label for="">{{ this.$t('EventType') }}</label>
					<v-select
						v-model="selectedType"
						:options="typeOptions"
						:placeholder="this.$t('EventType')"
						class="mb-2"
						multiple
					></v-select>
				</div>
			</div>
		</card-template>

		<card-template :show_header="false">
			<history-events-table
				:filter_range="filterDateRange"
				:filter_type="selectedType"
			/>
		</card-template>
	</div>
</template>

<script>
import moment from 'moment';
import DatePickerComponent from "../../../../../resources/js/components/DatePickerComponent.vue"
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'
import HistoryEventsTable from "./HistoryEventsTable.vue"

export default {
	name: 'HistoryEventsList',
	components: {
		vSelect,
    DatePickerComponent,
    HistoryEventsTable
	},
	props: {
		lang: {
			required: true
		}
	},
	mounted() {
		this.fetchTypeOptions();
	},
	computed: {

	},
	data() {
		return {
			filterDateRange: [null, null],
			selectedType: null,
			typeOptions: []
		};
	},
	methods: {
		fetchTypeOptions() {
			axios
				.get('/api-admin/history/history-events/types')
				.then((response) => {
					this.typeOptions = response.map((option) => ({
						label: option.type,
						value: option.type
					}));
				});
		},
    setDateFilter(payload) {
      this.filterDateRange = payload.time
    },
	}
};
</script>